import PropTypes from 'prop-types';

const LinkPropType = PropTypes.object;

const NavShape = { title: PropTypes.string };

const NavItemShape = {
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.shape(NavShape), LinkPropType])
  )
};

NavShape.body = PropTypes.arrayOf(PropTypes.shape(NavItemShape)).isRequired;

export default { navigation: PropTypes.shape(NavShape) };
